import React from "react";
 import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { Button } from "antd";
import StablePrime from "../components/Tables/StablePrime";


function LinePerformanceLineLeaders({ setPageHeader }) {
  setPageHeader("Line Performance");
  const handle = useFullScreenHandle();

  React.useEffect(()=>{
    
  })
  return (
    <div>
      <div
        style={{ textAlign: "right", padding: "0.5rem", marginBottom: "30px" }}
      >
        <Button
          onClick={handle.enter}
          type="danger"
          style={{ fontWeight: 600 }}
        >
          View FullScreen
        </Button>
      </div>
     
      <FullScreen handle={handle}>
      <div
          className="full-screenable-node"
          style={{
            backgroundColor: handle.active ? "#212121" : "none",
            width: handle.active ? "100vw" : "",
            height: handle.active ? "100vh" : "",
            paddingTop: handle.active ? "20px" : "0px",
          }}
        >
      <StablePrime url="lineperformancelineleaders" data={{}} identity="perfparam" />
  </div>
   </FullScreen>
    </div>
  );
}

export default LinePerformanceLineLeaders;
